<template>
	 <div class="container_component" >
		<div class="claim_code">
			<div class="claim_title">
				<div class="title_box">
					<div style="display: flex;align-items: center;">
						<div style="padding-right: 8px;">
							<img style=" width: 40px;height: 40px;" src="../../assets/img/log.png" alt="" />
						</div>
						<div class="text_item">
							切换游戏(<span style="font-family: MSYH !important;">*</span>)复制票
						</div>
						<div class="text_item text_active">
							兑奖
						</div>
						<div class="text_item">
							顾客( <span style="font-size: 18px;font-family:GGFS;font-weight: 500;">K3</span> )
						</div>
						<div class="text_item">
							功能收藏( Tab )
						</div>
					</div>
					
					<div class="right_code" >
						<div class="chat_img">
							<img 
							style="width: 100%;height: 100%;"
							src="../../assets/img/icon.png" alt="" srcset="" />
							<!-- <div class="chat_text">
								21
							</div> -->
						</div>
						<div class="text">
							【中国体育彩票足球6场半全场胜平负】第
						</div>
						<div class="text cath-text">【
							<el-input
								style="background-color: transparent;
								border: none; 
								box-shadow: none;
								color: #FFF;
								font-size: 17px;
								width: 42px;
								text-align: center;
								" 
								v-model="text99" type="text" 
								>
								</el-input>
							
							】</div>
						<div class="text" style="line-height: 45px; flex: 1;text-align: right;padding-right: 45px;">
							期开奖结果
						</div>
					</div>
				</div>
				<!-- <i @click="screenHeight" class="el-icon-back operate_icon"></i> -->
			</div>
			<div class="claim_content">
				<div class="content_box">
					<div class="claim_shop">
						<div class="shop_title">
							<div class="duijiang" style="color: #000;font-size: 22px;line-height: 50px;padding-left: 25px;">
								兑奖
							</div>
						</div>
						<div class="shop_screen">
							<div style="display: flex;justify-content: flex-end">
								
							<div class="screen_input" >
								<div class="input_text" style="margin-right: 10px;">
									序列号
								</div>
								<div class="input_code">
									<el-input 
									 class="input_ner"
									 type="numbew" 
									  maxlength="6"
									 v-model="inputText1">
									</el-input>
								</div>
								<div class="input_up">
									
								</div>
								<div class="input_code">
									<el-input 
									 class="input_ner"
									 type="numbew" 
									  maxlength="6"
									 v-model="inputText2">
									</el-input>
								</div>
								<div class="input_up">
									
								</div>
								<div class="input_code">
									<el-input 
									 class="input_ner"
									 type="numbew" 
									  maxlength="6"
									 v-model="inputText3">
									</el-input>
								</div>
								<div class="input_up">
									
								</div>
								<div class="input_code">
									<el-input 
									 class="input_ner"
									 type="numbew" 
									  maxlength="6"
									 v-model="inputText4">
									</el-input>
								</div>
								
								<div class="input_text" style="margin-left: 20px;margin-right: 10px;">
									密码
								</div>
								<div class="input_code2">
									<el-input 
									 class="input_ner"
									 type="numbew" 
									  maxlength="8"
									 v-model="inputText5">
									</el-input>
								</div>
							</div>
							
							</div>
							
							<div class="screen_btn">
								<div class=""></div>
								<div style="display: flex;margin-top: 20px;padding-bottom: 8px;">
									<div class="btn_item" 
									style="margin-right: 8px;background-color: #72D956;border: 1px solid #75A872;color: #FFF;">
										确定(Enter)
									</div>
									<div class="btn_item" 
									style="margin-right: 8px;background-color: #9BCEEF;border: 1px solid #88B0BF;color: #000;"
									>
										清除(F4)
									</div>
									<div @click="screenHeight" class="btn_item"
									style="background-color: #E5C071;border: 1px solid #CBC299;color: #000;"
									>
										返回(Esc)
									</div>
								</div>
							</div>
						</div>
					
						<div class="shop_content">
							<div class="shop_content_box">
								<div class="text_code">
									<div class="c_text_item zhongjiang-input">
										<div>查询时间:</div>
										<el-input
										style="width: 180px;text-align: left;padding: 0;"
										 class="input_num"
										 v-model="timeCode"></el-input> 
									</div>
									<div class="c_text_item">
										<div>中奖注数:</div> 
										<el-input 
										style="width: 20px;"
										 class="input_num"
										  maxlength="2"
										 v-model="note">
										</el-input>
										<div>注<span style="font-family: MSYH !important;">*</span></div>
										<el-input 
											style="width: 20px;"
										 class="input_num"
										  maxlength="2"
										 v-model="noteBei"></el-input> 
										<div style="margin-left: 0px;">倍</div>
									</div>
									<div class="c_text_item">
										<div>应退注数:</div>
										<el-input
											style="width: 20px;"
										 class="input_num"
										  maxlength="2"
										 v-model="note2">
										</el-input>
										<div>注<span style="font-family: MSYH !important;">*</span></div>
										<el-input
											style="width: 20px;"
										 class="input_num"
										  maxlength="2"
										 v-model="note2Bei"></el-input> 
										<div style="margin-left: 0px;">倍</div>
									</div>
									<div class="c_text_item zhongjiang-input">
										<div>中奖金额:</div>
										<el-input
										
											style="width: 180px;text-align: left;padding: 0;"
										 class="input_num"
										 v-model="note3">
										</el-input>
									</div>
									<div class="c_text_item mode_input">
										<div>应退金额:</div>
										<el-input
											style="width: 45px;text-align: left;"
										 class="input_num"
										 v-model="note4">
										</el-input>
										<div>元</div>
									</div>
									<div class="c_text_item mode_input">
										<div>兑奖状态:</div>
										<el-input
											style="width: 80px;text-align: left;"
										 class="input_num"
										 v-model="note6">
										 </el-input>
									</div>
									<div class="c_text_item mode_input" >
										<div>应付金额:</div>
										<el-input
											style="width: 88px;text-align: left;"
										 class="input_num"
										 v-model="note5">
										 </el-input>
									</div>
									<div class="c_text_item">
										应付金额=中奖金额+应退金额
									</div>
								</div>
								<div class="shop_content_bom">
									第1页/共1页
								</div>
							</div>
						
							<div class="shop_content_btn">
								<div class="shop_btn_item" style="margin-bottom: 10px;">
									上一页(<img class="top-img" src="../../assets/img/jintou.png" alt="" />)
								</div>
								<div class="shop_btn_item" style="margin-bottom: 55px;">
									下一页(<img class="btn-img" src="../../assets/img/jintou.png" alt="" />)
								</div>
								<div class="shop_btn_item">
									发奖(F1)
								</div>
							</div>
							
						</div>
					</div>
				</div>
			
				<div class="shop_bottom">
					<div class="bottom_left">
						<div class="conunt">
							<div style="display: flex;align-items: baseline;">
								<span style="font-family: AWARD1;font-size: 18px;font-weight: 500;margin-right: 8px;">小计</span>
								<span style="font-family: AWARD1;font-size: 18px;font-weight: 500;">：</span>
								<span class="b_input_text">
									<el-input
									style="background-color: transparent;
									border: none; 
									box-shadow: none;
									color: #FFF;
									font-size: 25px;
									" 
									@input="adjustWidth"
									class="width-input dynamic-width-input" 
									v-model="bonNote" type="text" 
									>
									</el-input>
								</span>
								<span style="font-family: medium;margin-right: 10px; font-family: MSYH;font-size: 14px;font-weight: 600;">注</span>
								<span class="b_input_text">
										<el-input
										style="background-color: transparent;
										border: none; 
										box-shadow: none;
										color: #FFF;
										font-size: 25px;
										" 
										@input="adjustWidth2"
										class="width-input dynamic-width-input2" 
										v-model="bonNote2" type="text" 
										>
										</el-input>
									</span>
								<span style="font-family: medium;margin-right: 10px; font-family: MSYH;font-size: 14px;font-weight: 600;">倍</span>
								<span class="b_input_text">
									<el-input
									style="background-color: transparent;
									border: none; 
									box-shadow: none;
									color: #FFF;
									font-size: 25px;
									" 
									@input="adjustWidth3"
									class="width-input dynamic-width-input3" 
									v-model="bonNote3" type="text" 
									>
									</el-input>
								</span>
								<span style="font-family: medium;margin-right: 10px; font-family: MSYH;font-size: 14px;font-weight: 600;">期</span>
								<span class="b_input_text">
									<el-input
									style="background-color: transparent;
									border: none; 
									box-shadow: none;
									color: #FFF;
									font-size: 25px;
									" 
									@input="adjustWidth4"
									class="width-input dynamic-width-input4" 
									v-model="bonNote4" type="text" 
									>
									</el-input>
								</span>
								<span style="font-family: medium;margin-right: 10px; font-family: MSYH;font-size: 14px;font-weight: 600;">元</span>
								
							</div>
						
							<div style="display: flex;align-items: baseline;margin-top: 5px;">
								<span style="font-family: medium;margin-right: 10px; font-size: 16px;font-weight: 600;">售</span>
								<span style="font-family: AWARD1;font-size: 18px;font-weight: 500;">:</span>
								<span class="b_input_text">
									<el-input
									style="background-color: transparent;
									border: none; 
									box-shadow: none;
									color: #FFF;
									font-size: 25px;
									" 
									@input="adjustWidth5"
									class="width-input dynamic-width-input5" 
									v-model="bonNote5" type="text" 
									>
									</el-input>
								</span>
								<span style="font-family: MSYH;font-size: 25px;font-weight: 500;">/</span>
								<span class="b_input_text">
									<el-input
									style="background-color: transparent;
									border: none; 
									box-shadow: none;
									color: #FFF;
									font-size: 25px;
									" 
									@input="adjustWidth6"
									class="width-input dynamic-width-input6" 
									v-model="bonNote6" type="text" 
									>
									</el-input>
								</span>
								<span style="font-family: medium;margin-right: 5px;;font-size: 16px;font-weight: 600;">兑</span>
								<span style="margin-right: 2px; font-family: AWARD1;font-size: 18px;font-weight: 500;">:</span>
								<span class="b_input_text  dui-text">
									<el-input
									style="background-color: transparent;
									border: none; 
									box-shadow: none;
									color: #FFF;
									font-size: 25px;
									" 
									@input="adjustWidth7"
									class="width-input dynamic-width-input7" 
									v-model="bonNote7" type="text" 
									>
									</el-input>
								</span>
							</div>
						</div>
						<div class="ying">
							<div style="display: flex;align-items: flex-end;">
								<span class="ying_btn">
									<span class="left_btn">应付</span>
									<span class="left_btn2">
										<span style="margin-right: 12px;">¥</span>
										<el-input
										style="background-color: transparent;
										border: none; 
										box-shadow: none;
										color: #FFF;
										font-size: 22px;
										" 
										class="width-input " 
										v-model="fukuan" type="text" 
										>
										</el-input>
									</span>
								</span>
								<span style="color: #FFF;margin-left: 3px;font-size: 20px;">元</span>
								<span class="close_ben">清除合计</span>
								<span class="close_ben">结算(K1)</span>
							</div>
							<div style="display: flex;align-items: center;">
								<div style="font-family: medium;font-weight: 600; margin-right: 10px;padding-left:85px; color: #FFF;font-size: 15px;">
									<div>可用</div>
									<div>额度</div>
								</div>
								<div style="display: flex;flex: 1;">
									<div class="money_box" style="width: 150px;">
										<el-input
											style="background-color: transparent;
											border: none; 
											box-shadow: none;
											color: #FFF;
											font-size: 22px;
											" 
											@input="adjustWidth8"
											class="width-input dynamic-width-input8" 
											v-model="moneyVal" type="text" 
											>
											</el-input>
									</div>
									<div class="money_box"
										style="display: flex;
										align-items: center;
										margin-top: 3px;
										padding-left: 30px;
										"
									>
										<div style="font-family: medium;width:58px;color: #FFF;font-size: 18px;font-weight: 600;">顾客 :</div>
										<el-input
											style="background-color: transparent;
											border: none; 
											box-shadow: none;
											color: #FFF;
											font-size: 20px;
											width: 56px;
											text-align: left;
											" 
											@input="adjustWidth9"
											class="width-input dynamic-width-input9" 
											v-model="gukeVal" type="text" 
											>
											</el-input>
									</div>
								</div>
								
							</div>
						</div>
					</div>
					<div class="bottom_right">
						<div class="top_time">
							<img class="time_log" src="../../assets/img/diannao.png" alt="" />
							<div id="wrapper" class="top_time_text"></div>
						</div>
						<div class="bottom_time">{{timeYear}}</div>
					</div>
				</div>
			
			
			</div>
		</div>
	</div>
</template>

<script>
import { login } from '@/utils/home'

	export default {
		data() {
			return {
				inputText1: '140400',
				inputText2: '430105',
				inputText3: '101580',
				inputText4: '607305',
				inputText5: '46414055',
				note: 0,
				noteBei: 1,
				note2: 0,
				note2Bei: 1,
				note3: 1,
				note4: '0.00',
				note5: '',
				note6: '可以兑奖',
				bonNote: 0,
				bonNote2: 1,
				bonNote3: 1,
				bonNote4: 0,
				bonNote5: 0,
				bonNote6: 0,
				bonNote7: '',
				moneyVal: '35000.00',
				gukeVal: '00007',
				fukuan: '',
				timeYear: '',
				text99: '26021',
				timeCode: ''
			}
		},
		mounted() {
			this.adjustWidth()
			this.adjustWidth2()
			this.adjustWidth3()
			this.adjustWidth4()
			this.adjustWidth5()
			this.adjustWidth6()
			this.adjustWidth7()
			this.adjustWidth8()
			this.adjustWidth9()
			const now = new Date();
			this.formatDateManually(now)
			this.getTimeDate()
			this.getTimeCode()
		},
		methods: {
			screenHeight() {
				this.$router.push('/');
			},
			getTimeCode() {
				const date = new Date();
				const year = date.getFullYear();
				const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的，所以要+1
				const day = date.getDate().toString().padStart(2, '0');
				let HoverTIme = date.getHours() > 9 ? (date.getHours()) : ("0" + date.getHours()); // 获取小时数(0-23)
				let MinyutesTime = date.getMinutes() > 9 ? (date.getMinutes()) : ("0" + date.getMinutes()); // 获取分钟数(0-59)
				let secondsTime = date.getSeconds() > 9 ? (date.getSeconds()) : ("0" + date.getSeconds()); // 获取秒(0-59)
				
				
				this.timeCode = `${year}-${month}-${day} ${HoverTIme}:${MinyutesTime}:${secondsTime}`;
			},
			getTimeDate() {
				var _wrapper = document.getElementById("wrapper");
				setInterval(() => {
					const date = new Date();
					let HoverTIme = date.getHours() > 9 ? (date.getHours()) : ("0" + date.getHours()); // 获取小时数(0-23)
					let MinyutesTime = date.getMinutes() > 9 ? (date.getMinutes()) : ("0" + date.getMinutes()); // 获取分钟数(0-59)
					let secondsTime = date.getSeconds() > 9 ? (date.getSeconds()) : ("0" + date.getSeconds()); // 获取秒(0-59)
					_wrapper.innerHTML = `${HoverTIme}:${MinyutesTime}:${secondsTime}`
				})
				
			},
			formatDateManually(date) {
			    const year = date.getFullYear();
			    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的，所以要+1
			    const day = date.getDate().toString().padStart(2, '0');
			    const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
			    const weekdayIndex = date.getDay(); // 获取星期几的索引，0代表星期日
			    const weekday = weekdays[weekdayIndex]; // 获取对应的中文星期表示
			    this.timeYear = `${year}/${month}/${day}(${weekday})`;
			},
			adjustWidth() {
			  const input = document.querySelector('.dynamic-width-input input'); // 获取输入框元素
			  if (input) {
				// 根据内容长度动态调整宽度
				input.style.width = `${Math.max(20, input.value.length * 20)}px`; // 假设每个字符宽度为10px，最小宽度为100px
			  }
			},
			adjustWidth2() {
			  const input = document.querySelector('.dynamic-width-input2 input'); // 获取输入框元素
			  if (input) {
				// 根据内容长度动态调整宽度
				input.style.width = `${Math.max(20, input.value.length * 20)}px`; // 假设每个字符宽度为10px，最小宽度为100px
			  }
			},
			adjustWidth3() {
			  const input = document.querySelector('.dynamic-width-input3 input'); // 获取输入框元素
			  if (input) {
				// 根据内容长度动态调整宽度
				input.style.width = `${Math.max(20, input.value.length * 20)}px`; // 假设每个字符宽度为10px，最小宽度为100px
			  }
			},
			adjustWidth4() {
			  const input = document.querySelector('.dynamic-width-input4 input'); // 获取输入框元素
			  if (input) {
				// 根据内容长度动态调整宽度
				input.style.width = `${Math.max(20, input.value.length * 20)}px`; // 假设每个字符宽度为10px，最小宽度为100px
			  }
			},
			adjustWidth5() {
			  const input = document.querySelector('.dynamic-width-input5 input'); // 获取输入框元素
			  if (input) {
				// 根据内容长度动态调整宽度
				input.style.width = `${Math.max(20, input.value.length * 20)}px`; // 假设每个字符宽度为10px，最小宽度为100px
			  }
			},
			adjustWidth6() {
			  const input = document.querySelector('.dynamic-width-input6 input'); // 获取输入框元素
			  if (input) {
				// 根据内容长度动态调整宽度
				input.style.width = `${Math.max(20, input.value.length * 20)}px`; // 假设每个字符宽度为10px，最小宽度为100px
			  }
			},
			adjustWidth7() {
			  const input = document.querySelector('.dynamic-width-input7 input'); // 获取输入框元素
			  if (input) {
				// 根据内容长度动态调整宽度
				input.style.width = `${Math.max(20, input.value.length * 20)}px`; // 假设每个字符宽度为10px，最小宽度为100px
			  }
			},
			adjustWidth8() {
			  const input = document.querySelector('.dynamic-width-input8 input'); // 获取输入框元素
			  if (input) {
				// 根据内容长度动态调整宽度
				input.style.width = `${Math.max(20, input.value.length * 15)}px`; // 假设每个字符宽度为10px，最小宽度为100px
			  }
			},
			adjustWidth9() {
			  const input = document.querySelector('.dynamic-width-input9 input'); // 获取输入框元素
			  if (input) {
				// 根据内容长度动态调整宽度
				input.style.width = `${Math.max(20, input.value.length * 15)}px`; // 假设每个字符宽度为10px，最小宽度为100px
			  }
			}
		}
		
	}
</script>

<style scoped lang="less">
	
	
	.container_component {
		height: calc(100vh);
	}
	.claim_code {
		width: 100%;
		height: 100%;
		.claim_title {
			height: 50px;
			background: linear-gradient(to bottom, #246EB2, #39C3F4);
			border-bottom: 2px solid #000;
			position: relative;
			.operate_icon {
				position: absolute;
				right: 70px;
				top: 15px;
				color: #FFF;
				font-size: 22px;
			}
			.title_box {
				width: 1010px;
				height: 100%;
				margin: 0 auto;
				display: flex;
				align-items: center;
				justify-content: space-between;
			}
			.text_item {
				height: 48px;
				line-height: 48px;
				color: #FFF;
				font-size:17px;
				padding: 0 10px;
				font-family: "MSYH" !important;
			}
			.text_active {
				border-right: 2px solid #2177AD;
				border-left: 2px solid #2177AD;
				color: #48B0D3;
				font-family: "medium" !important;
				background: linear-gradient(to bottom, #336DAA, #479ED4);
			}
			.right_code {
				height: 41px;
				background-color: #145380;
				border-radius: 4px;
				display: flex;
				align-items: center;
				width: 500px;
				font-family: "medium" !important;
				.chat_img {
					width: 25px;
					height: 20px;
					margin-left: 5px;
					margin-right: 10px;
					position: relative;
				}
				.chat_text {
					padding: 1px 3px;
					color: #fff;
					background-color: #F11D30;
					border: 2px solid #FFF;
					border-radius: 12px;
					font-size: 12px;
					font-weight: 500;
					position: absolute;
					left: 16px;
					top: -10px;
				}
				.text {
					line-height: 41px;
					font-size: 14px;
					color: #FFF;
				}
			}
		}
		
		.claim_content {
			background: linear-gradient(to bottom, #B4D9DF, #1A63AC);
			height: calc(100% - 50px);
			.content_box {
				width: 1010px;
				margin: 0 auto;
				padding-top: 10px;
				.claim_shop {
					width: 100%;
					background-color: #FFF;
					border-radius: 8px;
					border-left: 2px solid #9C9DA0;
					border-right: 2px solid #9C9DA0;
					border-bottom: 2px solid #9C9DA0;
					overflow: hidden;
				}
				.shop_title {
					height: 45px;
					background-color: #E3E3E3;
					background-image: url("../../assets/img/shop_title.png");
					background-size: 100% 100%;
					border-bottom: 2px solid #88998C;
				}
				.shop_screen {
					padding: 0 95px 0 0;
					border-bottom: 2px solid #88998C;
					.screen_input {
						padding-top: 25px;
						display: flex;
						justify-content: center;
						align-items: center;
						.input_text {
							font-size: 18px;
							font-family: "medium" !important;
							font-weight: 600;
						}
						.input_code2 {
							width: 150px;
							height: 35px;
							border: 2px solid #868686;
						}
						.input_code {
							width: 128px;
							height: 35px;
							border: 2px solid #868686;
						}
						.input_ner {
							font-size: 24px;
							font-family: "mediumOTF" !important;
						}
						.input_up {
							width: 20px;
							height: 2px;
							background-color: #868686;
						}
					}
					
					.screen_btn {
						display: flex;
						justify-content: space-between;
						.btn_item {
							width: 105px;
							height:38px;
							text-align: center;
							line-height: 38px;
							border-radius: 5px;
							font-size: 16px;
							font-family: "medium" !important;
							font-weight: 600;
						}
					}
				}
				
				.shop_content {
					height: 425px;
					padding: 8px 0;
					background-color: #DEF5F7;
					position: relative;
					.shop_content_box {
						width: 98%;
						height: 100%;
						background-image: url("../../assets/img/shop_bg.png");
						background-size: 100% 100%;
						margin: 0 auto;
						.text_code {
							width: 520px;
							margin: 0 auto;
							padding-top: 55px;
							font-size: 18px;
							margin-left:179px;
						}
						.c_text_item {
							display: flex;
							align-items: center;
							margin-bottom: 2px;
							font-family: "medium" !important;
							font-weight: 600;
						}
						.shop_content_box {
							width: 10px !important;
						}
					}
					
					.shop_content_bom {
						margin-top: 104px;
						width: 100%;
						text-align: center;
						color: #B4952E;
						font-size: 15px;
						font-family: "MSYH" !important;
						font-weight: 600;
					}
				
					.shop_content_btn {
						position: absolute;
						width: 130px;
						right: 24px;
						top: 98px;
						.shop_btn_item {
							width: 95px;
							height: 35px;
							line-height: 35px;
							border-radius: 2px;
							background-color: #C2E4B9;
							border: 1px solid #96A863;
							text-align: center;
							font-size: 16px;
							font-family: "MSYH" !important;
							font-weight: 600;
						}
						
						.top-img {
							width: 12.5px;
							height: 12.5px;
							transform: rotate(45deg);
						}
						.btn-img {
							width: 12.5px;
							height: 12.5px;
							transform: rotate(225deg);
						}
					}
				}
			
				
			}
		}
	
	}
	
	
	
	.shop_bottom {
		display: flex;
		width: 1010px;
		margin: 0 auto;
		.bottom_left {
			display: flex;
			flex: 1;
			.conunt {
				color: #FFF;
				width: 270px;
				padding-top: 10px;
			}
			.ying {
				flex: 1;
				padding-top: 5px;
				font-weight: 500;
				.ying_btn {
					width: 200px;
					height: 30px;
					border-radius: 5px;
					display: flex;
					overflow: hidden;
					.left_btn {
						height: 100%;
						width: 65px;
						text-align: center;
						line-height: 30px;
						background-color: #EF5F43;
						font-size: 20px;
						font-family: HTITI;
					}
					.left_btn2 {
						flex: 1;
						height: 100%;
						line-height: 30px;
						font-size: 22px;
						padding-left: 5px;
						display: flex;
						align-items: center;
						background-color: #DFDECE;
						font-family: HTITI;
					}
				}
			}
			.b_input_text {
				.input_money {
					color: #FFF !important;
					width: -moz-fit-content; /* Firefox */
					width: -webkit-fit-content; /* Chrome, Safari */
					width: fit-content; /* 标准语法 */
				}
				
			}
		}
	}
	
	.width-input {
		min-width: 20px; /* 初始最小宽度 */
		transition: width 0.3s; /* 平滑过渡效果 */
	}
	
	.bottom_right {
		border-left: 2px solid #acddf6;
		padding-top: 8px;
		.top_time {
			display: flex;
			align-items: flex-end;
			padding-left: 10px;
			.time_log {
				width: 30px;
				height: 40px;
				padding-bottom: 8px;
			}
			.top_time_text {
				margin-left: 5px;
				color: #FFF;
				font-size: 18px;
				font-weight: 600;
				font-family: "MSYH" !important;
			}
		}
		.bottom_time {
			margin-left: 5px;
			color: #FFF;
			font-size: 18px;
			font-weight: 600;
			font-family: "MSYH" !important;
		}
		
	}
	
	.clear_ben {
		width: 85px;
		height: 35px;
		background-color: #ECEEED;
		color: #BDC0BF;
		line-height: 35px;
		text-align: center;
		font-size: 14px;
		border-radius: 3px;
		margin-left: 8px;
		font-family: "medium" !important;
		box-shadow: 0px 0px 5px 0 #BDC0BF;
	}
	
	.close_ben {
		width: 85px;
		height: 35px;
		background-color: #F2D145;
		color: #624700;
		line-height: 35px;
		text-align: center;
		font-size: 14px;
		border-radius: 3px;
		margin-left: 8px;
		font-family: "MSYH" !important;
		box-shadow: 0px 0px 5px 0 #F2D145;
	}
	
	.duijiang {
		font-family: "medium" !important;
		font-weight: 600;
	}
	
	:deep(.el-input__inner) {
	  border: none;
	  padding: 0 0 0 2px;
	  color: #000;
	  text-align: left;
	  overflow: hidden;
	  font-weight: 500;
	  font-family: "MSYH" !important;
	  background-color: transparent;
	  
	}
	
	:deep(.c_text_item .el-input__inner) {
		background-color: transparent;
		padding: 0;
		font-family: "medium" !important;
		font-weight: 600;
		height: 23px;
		line-height: 40px;
		font-size: 18px;
		color: #2c3e50;
	}
	
	:deep .b_input_text .el-input__inner {
		color: #FFF;
		font-size: 28px;
	}
	:deep.left_btn2 .el-input__inner {
		text-align: left !important;
	}
	:deep(.mode_input .el-input__inner) {
		text-align: left !important;
		padding-left: 5px;
	}
	
	:deep.money_box .el-input__inner{
		color: #fff;
		text-align: left !important;
		font-family: "MSYH" !important;
		font-weight: 500;
	}
	
	/deep/ .zhongjiang-input .el-input__inner {
		text-align: left !important;
		padding-left: 5px;
	}
	
	/deep/ .cath-text .el-input__inner {
		color: #FFF;
		height: 45px;
		line-height: 45px;
		font-size: 14px;
	}
	
	/deep/ .dui-text .el-input__inner {
		text-align: left;
		padding-left: 5px;
	}
	
	
</style>